// Lib
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose, withProps } from '../../../../../../node_module_clones/recompose';

// Selectors
import { isUserSubscribed } from '../../../../../user/currentUserSelector';
import {
    emptyCurrentUserTrashSelector,
    trashedByCurrentUserOrderedListContentSelector,
    trashedByCurrentUserElementIdsSelector,
    trashFetchedSelector,
    trashFetchingSelector,
    trashHasMoreSelector,
    trashHasOlderSelector,
    trashedByCurrentUserOrderedListIdsSelector,
} from '../../store/trashSelector';

// Actions
import { emptyTrash, fetchNextPageOfTrash, fetchTrash } from '../../store/trashActions';

// Components
import TrashPopupPersonalEmptyPlaceholder from './TrashPopupPersonalEmptyPlaceholder';
import TrashPopupGenericTab from './TrashPopupGenericTab';

// Constants
import { TRASH_TABS } from '../../store/trashConstants';
import { WORKSPACE_SECTIONS } from '../../../../workspaceConstants';

const mapStateToProps = createStructuredSelector({
    isEmptyTrash: emptyCurrentUserTrashSelector,
    trashListOrderedContent: trashedByCurrentUserOrderedListContentSelector,
    trashListContentIds: trashedByCurrentUserOrderedListIdsSelector,
    trashElementIds: trashedByCurrentUserElementIdsSelector,
    hasMore: trashHasMoreSelector(TRASH_TABS.PERSONAL),
    hasOlder: trashHasOlderSelector(TRASH_TABS.PERSONAL),
    trashFetched: trashFetchedSelector(TRASH_TABS.PERSONAL),
    trashFetching: trashFetchingSelector(TRASH_TABS.PERSONAL),
    currentUserIsSubscribed: isUserSubscribed,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchEmptyTrash: () => dispatch(emptyTrash()),
    dispatchFetchTrash: () => dispatch(fetchTrash({ tab: TRASH_TABS.PERSONAL })),
    dispatchLoadMoreTrash: () => dispatch(fetchNextPageOfTrash({ tab: TRASH_TABS.PERSONAL })),
});

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withProps(() => ({
        PlaceholderComponent: TrashPopupPersonalEmptyPlaceholder,
        section: WORKSPACE_SECTIONS.TRASH_PERSONAL,
    })),
);

export default enhance(TrashPopupGenericTab);
